import { OrderAssetAvailability } from "../types/OrderAssetAvailability";

export const getAssetAvailabilityIconName = (availability: OrderAssetAvailability): string => {
    return availability === OrderAssetAvailability.PartialMatch ? "CircleHalfFull" : "StatusCircleInner";
};
